<template>
    <ListeFicheStock/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ListeFicheStock from "@/components/GesCom/FicheStock/ListeFicheStock.vue";

    export default defineComponent({
      name: "ListeFicheStockPage",
      components: {
        
        ListeFicheStock,
      },
    });
  </script>